import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import React, { useState } from 'react';

interface CollapsibleProps {
  trigger: React.ReactNode;
  children: React.ReactNode;
}

export const Collapsible: React.FC<CollapsibleProps> = ({ trigger, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <CollapsiblePrimitive.Root open={open} onOpenChange={setOpen}>
      <CollapsiblePrimitive.Trigger>{trigger}</CollapsiblePrimitive.Trigger>
      <CollapsiblePrimitive.Content>{children}</CollapsiblePrimitive.Content>
    </CollapsiblePrimitive.Root>
  );
};
